$(document).on("turbolinks:load", () => {
  if ($("body").hasClass("leads") && $("body").hasClass("show")) {
    $(".deleteBtn").on("click", (e) => {
      return confirm("Supprimer ce lead ?");
    });
  }
});
